import type { AttributeReviewMappingRow } from "@/hooks/useAttributeReview";
import { useFieldUsersByPath } from "@/hooks/useFieldUsers";
import { usePathLabels } from "@/hooks/usePathLabels";
import type { AgentAnswers } from "@/lib/attributeReview/reviewRow.types";
import { usedBySummary } from "@/lib/attributeReview/usedBySummary";

import { SecondCheck } from "./SecondCheck";
import { TwoAnswers } from "./TwoAnswers";

type Props = {
  row: AttributeReviewMappingRow;
  marketplace: string;
  pickedPath: string | null;
  pickedKind: string | null;
  setPath?: (path: string | null, kind?: string | null) => void;
  fieldLabelOf: (id: string) => string;
  onCopy?: (copyOf: string) => void;
};

export function ReviewDrawerAgentPanel({
  row,
  marketplace,
  pickedPath,
  pickedKind,
  setPath,
  fieldLabelOf,
  onCopy,
}: Props) {
  const labelOf = usePathLabels(Boolean(row.agent));
  const agent = row.agent as AgentAnswers | null;
  const answerPaths = (agent?.answers ?? []).flatMap((a) =>
    a.path ? [a.path] : [],
  );
  const usersOf = useFieldUsersByPath(answerPaths);
  if (!agent) return null;
  const suggested = row.suggested as string[];
  return (
    <>
      <TwoAnswers
        agent={agent}
        pickedPath={pickedPath}
        pickedKind={pickedKind}
        labelOf={labelOf}
        onUse={setPath}
        fieldLabelOf={fieldLabelOf}
        onCopy={onCopy}
        usedTitleOf={(path) =>
          usersOf[path]
            ? usedBySummary(usersOf[path], marketplace).title
            : undefined
        }
      />
      {suggested.length > 0 && setPath && (
        <SecondCheck
          suggested={suggested}
          pickedPath={pickedPath}
          labelOf={labelOf}
          onUse={setPath}
        />
      )}
    </>
  );
}
